<template>
  <AppNavbar />
  <div class="d-flex flex-column maintenance-layout">
    <AppHeader title="Mantenimiento" class="header-compact px-4 border-bottom">
      <template #buttons>
        <button
          v-if="showBackButton"
          type="button"
          class="btn btn-outline-secondary maintenance-back-button"
          @click="goBack"
        >
          <i class="bi bi-arrow-left"></i>
          Volver
        </button>
      </template>
    </AppHeader>
    <div class="d-flex flex-grow-1">
      <aside class="sidebar p-3">
        <ul class="nav flex-column gap-1">
          <li v-for="item in visibleMenu" :key="item.name" class="nav-item">
            <router-link class="nav-link" :to="item.to" exact-active-class="active">
              <i :class="item.icon + ' me-2'"></i>{{ item.label }}
            </router-link>
          </li>
        </ul>
      </aside>
      <main class="flex-fill p-4">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppNavbar from '@/components/AppNavbar.vue'
import { hasPermission } from '@/services/authSessionService'

export default {
  name: 'MaintenanceLayout',
  components: {
    AppHeader,
    AppNavbar
  },
  data() {
    return {
      menu: [
        { name: 'maintenance-home', label: 'Resumen', to: { name: 'MaintenanceHome' }, icon: 'bi bi-grid-1x2' },
        { name: 'maintenance-operational', label: 'Operativo', to: { name: 'MaintenanceOperational' }, icon: 'bi bi-sliders' },
        { name: 'maintenance-fiscal', label: 'Fiscal', to: { name: 'MaintenanceFiscalDashboard' }, icon: 'bi bi-receipt-cutoff' },
        { name: 'maintenance-users', label: 'Usuarios', to: { name: 'UserManagement' }, icon: 'bi bi-people' },
        { name: 'maintenance-cashboxes', label: 'Cajas', to: { name: 'MaintenanceCashboxes' }, icon: 'bi bi-safe2' },
        { name: 'maintenance-establishments', label: 'Establecimientos', to: { name: 'MaintenanceFiscalEstablishments' }, icon: 'bi bi-building' },
        { name: 'maintenance-points', label: 'Puntos', to: { name: 'MaintenanceFiscalPoints' }, icon: 'bi bi-diagram-3' },
        { name: 'maintenance-timbrados', label: 'Timbrados', to: { name: 'MaintenanceFiscalTimbrados' }, icon: 'bi bi-journal-text' },
        { name: 'maintenance-series', label: 'Series', to: { name: 'MaintenanceFiscalSeries' }, icon: 'bi bi-123' },
        { name: 'maintenance-facturacion', label: 'Facturación', to: { name: 'MaintenanceFiscalFacturacion' }, icon: 'bi bi-exclamation-triangle' }
      ]
    }
  },
  computed: {
    visibleMenu() {
      // CFE-E2: estas cinco pantallas pasaron de `ver_depositos` a
      // `ver_facturacion_electronica`/`gestionar_facturacion_electronica`
      // (SPEC_CONFIG_FISCAL_POR_EXPORT_v0.1.md, H4) — sin este filtro,
      // `encargado_deposito` seguía viendo el link y se topaba con un 403
      // recién al entrar, porque antes ninguna de las cinco se filtraba acá.
      const fiscalScreens = new Set([
        'maintenance-fiscal',
        'maintenance-establishments',
        'maintenance-points',
        'maintenance-timbrados',
        'maintenance-series'
      ])
      return this.menu.filter((item) => {
        if (item.name === 'maintenance-users') return hasPermission('ver_usuarios')
        if (item.name === 'maintenance-cashboxes') return hasPermission('actualizar_deposito')
        if (item.name === 'maintenance-facturacion') return hasPermission('gestionar_facturacion_electronica')
        if (fiscalScreens.has(item.name)) return hasPermission('ver_facturacion_electronica')
        // `Operativo` y `Resumen` caían en el `return true` de abajo, así que
        // los veía cualquiera que llegara al layout. Se gatean con el mismo
        // permiso que su ruta, para no ofrecer un enlace que el guard rechaza.
        // (`Balanzas` salió de la lista entera: D-R6.)
        if (item.name === 'maintenance-operational') return hasPermission('ver_depositos')
        return true
      })
    },
    showBackButton() {
      return this.$route?.name && this.$route.name !== 'MaintenanceHome'
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
        return
      }
      this.$router.push({ name: 'MaintenanceHome' })
    }
  }
}
</script>

<style scoped>
.maintenance-layout {
  min-height: 100vh;
}

.header-compact {
  padding-top: .5rem;
  padding-bottom: .5rem;
}

.sidebar {
  width: 260px;
  background: #fff;
  border-right: 1px solid #e5e5e5;
}

.maintenance-back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.sidebar .nav-link {
  color: #111;
  border-radius: .25rem;
  padding: .6rem .9rem;
}

.sidebar .nav-link:hover {
  background: #f2f2f2;
  color: #111;
}

.sidebar .nav-link.active {
  background: #111;
  color: #fff;
  font-weight: 600;
}

main {
  background: #f9f9f9;
  overflow-y: auto;
}
</style>
